import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Box, IconButton as MuiIconButton, TextField as MuiTextField, Stack, Typography } from "@mui/material";
import { styled } from "@mui/styles";

/**
 * @typedef {object} InputWithHiddenIconProps
 * @property {string} label
 * @property {boolean} isHidden
 * @property {import ("@mui/material").TextFieldProps} TextFieldProps
 * @property {import ("@mui/material").IconButtonProps} IconButtonProps
 */

/**
 *
 * @param {InputWithHiddenIconProps} props
 * @returns
 */

const InputWithHiddenIcon = props => {
  const { label, isHidden, TextFieldProps, IconButtonProps } = props;

  return (
    <Box>
      <Typography fontSize={13} fontWeight={600} mb={0.5}>
        {label}
      </Typography>

      <Stack direction="row" spacing={1} maxWidth={800} alignItems="center">
        <TextField fullWidth variant="outlined" {...TextFieldProps} />

        <IconButton size="small" {...IconButtonProps}>
          {isHidden ? (
            <VisibilityOutlined sx={{ fontSize: "24px", color: "#666" }} />
          ) : (
            <VisibilityOffOutlined sx={{ fontSize: "24px", color: "#666" }} />
          )}
        </IconButton>
      </Stack>
    </Box>
  );
};

export default InputWithHiddenIcon;

const TextField = styled(MuiTextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    "& .MuiInputBase-input": {
      padding: "10px 14px",
    },
  },
});

const IconButton = styled(MuiIconButton)({
  border: "1px solid #ccc",
  borderRadius: 8,
  backgroundColor: "#fff",
  width: 40,
  height: 40,
  marginLeft: 8,
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",

  "&:hover": {
    backgroundColor: "#CBCACA",
  },

  "&:disabled": {
    opacity: "50%",
  },
});
